// Types
import type { AxiosError } from 'axios';

import type {
    dataNotificationsProps,
    loadMoreNotificationsType
} from '@/utils/hooks/swr/useNotifications';
import type { mutateNotificationsType } from '@/utils/hooks/swr/useNotifications';

import LoadMoreButton from '@/components/composite/Button/LoadMoreButton';
// Components
import Notifications from '@/components/composite/Notifications';
import DataNotificationEmpty from '@/components/pages/notifications/DataNotificationEmpty';
import DataNotificationsErrorFallback from '@/components/pages/notifications/DataNotificationsErrorFallback';
import ListNotificationPlaceholder from '@/components/pages/notifications/ListNotificationPlaceholder';

import ButtonDeleteNotification from './actions/ButtonDeleteNotification';

type ListNotificationsProps = {
    dataNotifications: dataNotificationsProps[];
    notificationsError: AxiosError;
    isLoadMore: boolean;
    isLoadingMore: boolean;
    isLoadingInitialData: boolean;
    loadMoreNotifications: loadMoreNotificationsType;
    mutateNotifications: mutateNotificationsType;
};

const ListNotifications = ({
    dataNotifications,
    notificationsError,
    isLoadMore,
    isLoadingMore,
    isLoadingInitialData,
    mutateNotifications,
    loadMoreNotifications
}: ListNotificationsProps) => {
    if (isLoadingInitialData) {
        return <ListNotificationPlaceholder />;
    }

    if (notificationsError) {
        return (
            <DataNotificationsErrorFallback
                resetErrorBoundary={() => mutateNotifications(undefined)}
            />
        );
    }

    if (dataNotifications?.[0]?.notifications.length === 0) {
        return <DataNotificationEmpty />;
    }

    return (
        <main>
            <div className="flex flex-col gap-3">
                {dataNotifications.map((item) =>
                    item.notifications.map((notification) => (
                        <div key={notification.id} className="group relative">
                            <Notifications notification={notification} />
                            <ButtonDeleteNotification
                                notification={notification}
                                mutateNotifications={mutateNotifications}
                            />
                        </div>
                    ))
                )}
            </div>
            {isLoadMore ? (
                <div className="mt-3 flex justify-center">
                    <LoadMoreButton
                        loadMoreItems={loadMoreNotifications}
                        isLoadingMore={isLoadingMore}
                    />
                </div>
            ) : null}
        </main>
    );
};

ListNotifications.displayName = 'ListNotifications';

export default ListNotifications;
